import { render, staticRenderFns } from "./CatalogDetails.vue?vue&type=template&id=010e7cf8&scoped=true"
import script from "./CatalogDetails.vue?vue&type=script&lang=js"
export * from "./CatalogDetails.vue?vue&type=script&lang=js"
import style0 from "./CatalogDetails.vue?vue&type=style&index=0&id=010e7cf8&prod&scoped=true&lang=css"
import style1 from "./CatalogDetails.vue?vue&type=style&index=1&id=010e7cf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e7cf8",
  null
  
)

export default component.exports